import React from "react";

import { SuggestionListMobile } from "../../SuggestionList/Mobile";

import { DropdownProps } from "../types";
import { DropdownWrapperMobile } from "./styles";

/**
 * Componente Dropdown (Mobile)
 *
 * Uma lista suspensa para sugestões, adaptada para versões móveis.
 *
 * @param {boolean} isVisible - Controla a visibilidade do dropdown.
 * @param {SuggestionListProps | { items: Airport[] }} suggestions - Sugestões exibidas na lista.
 * @param {(origin: Airport) => void} onSelect - Função executada ao selecionar um item.
 */
export const DropdownMobile: React.FC<DropdownProps> = ({
  suggestions,
  isVisible,
  onSelect,
}) => {
  if (!isVisible) return null;

  const renderSuggestions = () => {
    if (suggestions && "items" in suggestions) {
      return suggestions.items.map((item, index) => (
        <div
          key={index}
          onClick={() => onSelect(item)}
          style={{
            cursor: "pointer",
            padding: "8px 12px",
          }}
        >
          {item.name}
        </div>
      ));
    }
    return <SuggestionListMobile {...suggestions} onSelect={onSelect} />;
  };

  return (
    <DropdownWrapperMobile
      role="listbox"
      isVisible={isVisible}
      aria-hidden={!isVisible}
    >
      {renderSuggestions()}
    </DropdownWrapperMobile>
  );
};
